import { render } from "./LogoHimalia.vue?vue&type=template&id=7bea2f20&scoped=true&ts=true"
import script from "./LogoHimalia.vue?vue&type=script&lang=ts"
export * from "./LogoHimalia.vue?vue&type=script&lang=ts"

import "./LogoHimalia.vue?vue&type=style&index=0&id=7bea2f20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea2f20"]])

export default __exports__